<h1 class="text-3xl text-rose-500 bg-orange-400">{{ title() }}</h1>
<router-outlet />
